/*
 * 项目报价管理组件
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
*/

import { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    message,
    Table,
    Input,
    Button,
    InputNumber,
    Space,
    Tag,
    theme,
    Statistic,
    Select,
} from 'antd';
import { PlusOutlined, ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './OfferEntity';
import OfferAuditEntity from './OfferAuditEntity';
import OfferPrinter from './OfferPrinter';

const MODULENAME = CNF.navItems[0].submenu[2].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[2].ptn;
const MODULENAME_URL = CNF.navItems[0].submenu[2].url;

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, refresh, preGroup, setOpen } = props;

    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            green6,
            green1,
            red6,
            red1,
            cyan1,
            cyan6,
            blue1,
            blue6,
            fontSize,
            pageSize,
        },
    } = theme.useToken();

    const [record, setRecord] = useState(null);
    const [openAudit, setOpenAudit] = useState(false);
    const [openPreview, setOpenPreview] = useState(false);

    const update = useCallback((record) => {
        setOpen(true, record);
    }, [setOpen]);

    const audit = useCallback((open, record = null) => {
        setRecord(record);
        setOpenAudit(open);
    }, []);

    const preview = useCallback((open, record = null) => {
        setRecord(record);
        setOpenPreview(open);
    }, []);

    /**
    * 操作选项
    * @param {*} action 
    * @param {*} record 
    */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.AUDIT:
                audit(true, record);
                break;
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh, audit, update]);

    /**
     * 调整比例
     * @param {*} record 
    */
    const adjustmentRatio = (record) => {
        if (parseFloat(record.amount) >= parseFloat(record.init_amount)) {
            let initTotal = parseFloat(record.init_amount) + parseFloat(record.init_tax_amount);
            let total = parseFloat(record.amount) + parseFloat(record.tax_amount);
            return ((total - initTotal) / initTotal * 100).toFixed(CNF.DPL);
        } else {
            let initTotal = parseFloat(record.init_amount) + parseFloat(record.init_tax_amount);
            let total = parseFloat(record.amount) + parseFloat(record.tax_amount);
            return '-' + ((initTotal - total) / initTotal * 100).toFixed(CNF.DPL);
        }
    }

    /**
     * 核减比例
     * @param {*} record 
    */
    const deductionRatio = (record) => {
        if (parseFloat(record.audited_amount) > 0) {
            let total = parseFloat(record.amount) + parseFloat(record.tax_amount);
            let auditedTotal = parseFloat(record.audited_amount) + parseFloat(record.audited_tax_amount);
            return ((total - auditedTotal) / total * 100).toFixed(CNF.DPL);
        } else {
            return '-'
        }
    }

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_audit') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );

    const columns = useMemo(() => [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        {
            title: '报价名称', key: 'name',
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: 0, border: 0, height: 22 }}
                onClick={() => { preview(true, record); }}>{record.name}</Button>
        },
        {
            title: '版本', key: 'version',
            render: (record) => {
                return 'v' + record.version;
            }
        },
        {
            title: '初始报价总计(元)', key: 'init_total',
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '80%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={parseFloat(record.init_amount) + parseFloat(record.init_tax_amount)} /></Tag>
        },
        {
            title: '报价总计(元)', key: 'total',
            render: (record) => <Tag color={green1} style={{ width: '80%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: green6 } }} value={parseFloat(record.amount) + parseFloat(record.tax_amount)} /></Tag>
        },
        {
            title: '审核总计(元)', key: 'audited_amount',
            render: (record) => <Tag color={red1} style={{ width: '80%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: red6 } }} value={parseFloat(record.audited_amount) + parseFloat(record.audited_tax_amount)} /></Tag>
        },
        {
            title: '调整比例(%)', key: 'adjustment_ratio',
            render: (record) => <Tag color={cyan1} style={{ width: '80%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: cyan6 } }} value={adjustmentRatio(record)} /></Tag>
        },
        {
            title: '核减比例(%)', key: 'deduction_ratio',
            render: (record) => <Tag color={blue1} style={{ width: '80%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: blue6 } }} value={deductionRatio(record)} /></Tag>
        },
        { title: '下载次数', dataIndex: 'download_count', key: 'download_count', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '状态', dataIndex: 'status', key: 'status', width: CNF.tableStatusColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation, blue1, blue6, colorPrimary, colorPrimaryBg, cyan1, cyan6, green1, green6, preview, red1, red6, fontSize]);

    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条`,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
            {openPreview && record && <OfferPrinter
                preGroup={preGroup}
                btnLists={btnLists}
                open={openPreview}
                setOpen={setOpenPreview}
                record={record}
                refresh={refresh}
            />
            }
            {openAudit && record && <OfferAuditEntity
                preGroup={preGroup}
                btnLists={btnLists}
                open={openAudit}
                setOpen={setOpenAudit}
                record={record}
                refresh={refresh}
            />
            }
        </>
    );
}

const ProjectOffer = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState('');
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [name, setName] = useState('');
    const [version, setVersion] = useState(0);

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);
    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);
    const handleNameChange = useCallback((e) => {
        setName(e.target.value);
        setCurrentIndex(1);
    }, []);
    const handleVersionChange = useCallback((value) => {
        setVersion(value);
        setCurrentIndex(1);
    }, []);
    const setOpenModal = useCallback((value, record = null) => {
        setOpen(value);
        setRecord(record);
    }, []);
    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            name,
            version,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, status, name, version]);


    /**
     * 导出 Excel
     * @param {*} record 
     * @param {*} data 
     */
    const exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '项目报价管理.' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '项目报价清单',  //  excel文件中sheet页名称
                sheetHeader: [
                    '报价名称',
                    '版本号',
                    '金额(元)',
                    '税费(元)',
                    '审核金额(元)',
                    '审核税费(元)',
                    '有效期限(月)',
                    '客户名称',
                    '地址',
                    '联系人',
                    '电话',
                    '邮箱',
                    '报价单位',
                    '地址',
                    '联系人',
                    '电话',
                    '邮箱',
                    '报价日期',
                    '状态',
                    '备注'
                ],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出数据
     */
    const exportGetData = () => {
        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            name,
            version,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                if (data.dat.length > 0) {
                    //  删除非必须字段
                    var d = [];
                    for (let i = 0; i < data.dat.length; i++) {
                        var item = data.dat[i]
                        delete item['key'];
                        delete item['create_username'];
                        delete item['create_displayname'];
                        delete item['create_time'];
                        delete item['update_time'];
                        delete item['init_amount'];
                        delete item['init_tax_amount'];
                        d.push(item);
                    }
                    exportAsExcel(d);
                } else {
                    exportAsExcel([]);
                }
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        })
    }

    // 按钮权限判断
    const hasCreate = btnLists.includes(MODULENAME_PTN + '_create');
    const hasExport = btnLists.includes(MODULENAME_PTN + '_export');

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input
                    placeholder='报价名称'
                    value={name}
                    onChange={handleNameChange}
                />
                <InputNumber
                    placeholder='版本号'
                    prefix='版本号: v'
                    style={{ minWidth: 150 }}
                    min={0}
                    step={1}
                    value={version || ''}
                    onChange={handleVersionChange}

                />
                <Select
                    allowClear
                    placeholder='状态'
                    style={{ width: '100%' }}
                    popupMatchSelectWidth={false}
                    onChange={handleStatusChange}
                    value={status || undefined}
                    options={CNF.offerStatus.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                {hasCreate && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={() => {
                            create();
                        }}>
                        {CNF.actionName.CREATE}
                    </Button>
                )}
                {hasExport && (
                    <Button
                        title={CNF.actionName.EXPORT + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<ExportOutlined />}
                        onClick={() => {
                            exportGetData();
                        }}>
                        {CNF.actionName.EXPORT}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
                actionSource='OFFER'
            />
        </>
    );
}

export default ProjectOffer;